import styled from 'styled-components';

import { media } from '@savgroup-front-common/constants';
import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

import { fontStyle } from '../../theme/helpers/fontStyle';
import { Button } from '../button';

export const $ButtonGroupWrapper = styled.div`
  display: flex;
  margin-left: ${spacing('lg')};

  & > button:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-left: 1px solid transparent;
  }

  & > button:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
`;

export const $ListPaginationButton = styled(Button)`
  &,
  &:focus,
  &:active,
  &:visited {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: ${spacing('xxs')};
    gap: ${spacing(2.5)};
    background-color: transparent;
    border: 1px solid ${({ theme }) => theme.newUI.variationColors.light3};
    height: auto;
    min-height: auto;
    width: auto;
    min-width: auto;

    & > span > svg {
      color: ${({ theme }) => theme.newUI.defaultColors.primary};
      margin-right: 0;
    }

    &[disabled] {
      background-color: transparent;
      & > span > svg {
        color: ${({ theme }) => theme.colors.default};
      }
    }
  }

  &:hover {
    background-color: ${({ theme }) => theme.systemColors.defaultBackground};
    border: 1px solid ${({ theme }) => theme.colors.default};
    &:not(:first-child) {
      border-left: 1px solid transparent;
    }
    & > span > svg {
      color: ${({ theme }) => theme.newUI.defaultColors.primary};
    }
  }
`;

export const $ListPaginationInputText = styled.div`
  display: flex;
  font-style: normal;
  font-weight: ${fontWeight('normal')};
  ${fontStyle('xs')};
  text-align: right;
  color: ${({ theme }) => theme.colors.mainTextColor};
  white-space: nowrap;
  margin-left: ${spacing('sm')};

  ${fontStyle('xs')};
  color: ${({ theme }) => theme.newUI.defaultColors.secondaryText};
  font-weight: ${fontWeight('medium')};
`;

export const $ListPaginationInterval = styled.button<{
  $isActive: boolean;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${spacing(1.5)} ${spacing('sm')};
  gap: ${spacing(2.5)};
  border: 1px solid ${({ theme }) => theme.newUI.variationColors.light3};
  border-right: none;
  border-radius: 0;
  cursor: pointer;
  color: ${({ theme, $isActive }) => {
    if ($isActive) {
      return theme.colors.white;
    }

    return theme.colors.mainTextColor;
  }};

  background-color: ${({ theme, $isActive }) => {
    return $isActive
      ? theme.newUI.variationColors.dark1
      : theme.systemColors.defaultBackground;
  }};
`;

export const $ListPaginationIntervalWrapper = styled.div`
  display: flex;
  align-items: center;

  & button:first-child {
    border-top-left-radius: ${({ theme }) =>
      `${theme.tw.radius.sm} !important`};
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: ${({ theme }) =>
      `${theme.tw.radius.sm} !important`};
  }

  & button:last-child {
    border-top-left-radius: 0;
    border-top-right-radius: ${({ theme }) =>
      `${theme.tw.radius.sm} !important`};
    border-bottom-right-radius: ${({ theme }) =>
      `${theme.tw.radius.sm} !important`};
    border-bottom-left-radius: 0;

    border-right: 1px solid ${({ theme }) => theme.colors.default};
    margin-right: ${spacing('sm')};
  }
`;

export const $ListPaginationPage = styled.div`
  display: flex;
  align-items: center;

  && input {
    width: 70px;
    text-align: center;
    height: auto;
    padding: ${spacing('xs')} ${spacing('sm')};
    border-color: ${({ theme }) =>
      theme.newUI.variationColors.light3} !important;
  }

  && > div {
    margin-bottom: 0;
  }
`;

export const $ListPaginationWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const $Spacer = styled.div`
  flex: 1;
`;

export const $PaginationPerPage = styled.span`
  font-weight: ${fontWeight('medium')};
  color: ${({ theme }) => theme.newUI.defaultColors.secondaryText};
  ${fontStyle('xs')};

  @media ${media.maxWidth.sm} {
    display: none;
  }
`;
